import { http } from "./http.js";

async function getPermission(id) {
  const response = await http.get(`roles/${id}/permissions`);
  return response.data;
}

async function createPermissions(id, permissions) {
  const response = await http.post(`roles/${id}/permissions`, {
    permissions,
  });
  return response;
}

async function getUserRoles() {
  const response = await http.get("user-roles");
  return response.data;
}
export { getPermission, createPermissions, getUserRoles };
